// extracted by mini-css-extract-plugin
export default {"label":"StatusBadge_label__J78bP"};